var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-map ml-4 mr-4" },
    [
      _vm.type === "create"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col company-h1" }, [
                  _c("button", {
                    staticClass: "btn btn-back",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.setCompanyStep("companies-info")
                      }
                    }
                  }),
                  _vm._v("\n        Create Company\n      ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { type: "button", disabled: _vm.buttonDisabled }
                    },
                    [
                      _vm._v("\n          Save\n          "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("companies-steps-menu", { attrs: { type: "create" } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "edit"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row py-3 align-items-center company-header" },
              [
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("h2", { staticClass: "company-h1 mr-3" }, [
                      _c("button", {
                        staticClass: "btn btn-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/companies")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          " + _vm._s(_vm.company.name) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.company.status
                      ? [
                          _vm.company.status.name === "Active"
                            ? _c("span", { class: "btn-status btn-active" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Inactive"
                            ? _c("span", { class: "btn-status btn-closed" }, [
                                _vm._v(_vm._s(_vm.company.status.name))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.company.status.name === "Setup Incomplete"
                            ? _c(
                                "span",
                                { class: "btn-status btn-ncover info-company" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.company.status.name) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btn btn-link p-0 tippy-popup tippy-info",
                                      on: {
                                        mouseover: function($event) {
                                          _vm.showTooltipPrefix = true
                                        },
                                        mouseout: function($event) {
                                          _vm.showTooltipPrefix = false
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.showTooltipPrefix
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "popover tippy-info-popover"
                                        },
                                        [
                                          _vm._v(
                                            "\n              Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-8 d-flex align-items-center justify-content-end"
                  },
                  [
                    _vm.$_can("companies.review.request")
                      ? _c("companies-visibility-bar", {
                          attrs: { company: _vm.company },
                          on: {
                            saved: function($event) {
                              _vm.$emit("saved")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary ld-ext-right ml-5",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { type: "button", disabled: _vm.buttonDisabled }
                      },
                      [
                        _vm._v("\n          Save\n          "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-3 w-100" }, [
        _c("h5", { staticClass: "companies-sub-page-title" }, [_vm._v("Tier")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-center flex-wrap" },
          _vm._l(_vm.tiers, function(tier) {
            return _c("div", { key: tier.id, staticClass: "tier-card m-1" }, [
              _c(
                "div",
                { staticClass: "d-flex flex-column align-items-center" },
                [
                  _c("div", { staticClass: "tier-tittle w-100" }, [
                    _vm._v(_vm._s(tier.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("span", { staticClass: "tier-percent" }, [
                        _vm._v(_vm._s(tier.percentage) + "%")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "tier-commission" }, [
                        _vm._v("Commission")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tier-description mb-3" }, [
                    _vm._v(_vm._s(tier.description))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "tier-properties" },
                _vm._l(tier.mod_tier_options, function(tierOption) {
                  return _c("li", { key: tierOption.id }, [
                    _vm._v(_vm._s(tierOption.name))
                  ])
                })
              ),
              _vm._v(" "),
              tier.id === _vm.company.mod_tier_requested_id
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-tier-requested",
                      class: tier.cta_style
                    },
                    [_vm._v("\n          Requested tier level\n        ")]
                  )
                : tier.id === _vm.company.mod_tier_id
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-current-tier-level",
                        class: tier.cta_style
                      },
                      [_vm._v("\n          Your current tier level\n        ")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-tier-chose",
                        class: tier.cta_style,
                        on: {
                          click: function($event) {
                            _vm.selectTier(tier)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              tier.cta_text
                                ? tier.cta_text
                                : "Choose " + tier.name
                            ) +
                            "\n        "
                        )
                      ]
                    )
            ])
          })
        )
      ]),
      _vm._v(" "),
      _vm.selectedTier !== null
        ? _c(
            "modal",
            {
              attrs: { container: "l-modal-container-sm" },
              on: {
                close: function($event) {
                  _vm.selectedTier = null
                }
              }
            },
            [
              _c("template", { slot: "header" }, [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column align-items-center px-3",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/img/tier-select.jpg"),
                      alt: "Tier select"
                    }
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "text-center mt-4" }, [
                    _vm._v("You've requested to change your tier level to "),
                    _c("span", { staticClass: "text-blue" }, [
                      _vm._v(_vm._s(_vm.selectedTier.name))
                    ]),
                    _vm._v(".")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center mt-3 px-3" }, [
                    _vm._v(
                      "\n        Your recurring payouts will continue according to your selected schedule and this will not affect your website visibility.\n        Commission changes will apply only to bookings made after the tier plan change is approved by Mod24.\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center w-100 mt-3"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary mr-1 w-50 btn-decline",
                          on: {
                            click: function($event) {
                              _vm.selectedTier = null
                            }
                          }
                        },
                        [_vm._v("\n          No, go back.\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-1 w-50 btn-accept",
                          on: {
                            click: function($event) {
                              _vm.choseTier(_vm.selectedTier)
                            }
                          }
                        },
                        [_vm._v("\n          Yes, accept.\n        ")]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [_vm._v(" ")])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "description-text" }, [
      _vm._v(
        "You can change your tier level here and see benefits you can get if you opy for the change "
      ),
      _c("br"),
      _vm._v(
        " Changing a tier plan will require Mod24 verification, it will take up to 48h to get the approval."
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60d78c81", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d78c81","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/mod24settings/CompaniesTier.vue
// module id = null
// module chunks = 